import React from 'react';
import ReactDOM from "react-dom";
import ParticleField from '../js/libs/particle3d';

/**
 * The default configuation for the ParticleField component
 *
 * Any option passed in via props will overwrite the default config
 */

const ratio = (window.innerWidth / window.innerHeight)

 const config = {
    showCube: false,
    dimension: '3D',
    velocity: 2,
    boundaryType: 'passthru',
    antialias: false,
    direction: {
      xMin: -0.105 + (ratio * 0.03),
      xMax: 0.105 - (ratio * 0.03),
      yMin: -0.105 + (ratio * 0.03),
      yMax: 0.105 - (ratio * 0.03),
      zMin: 0.7,
      zMax: 1
    },
    lines: {
      colorMode: 'solid',
      color: '#d1a729',
      transparency: 0,
      limitConnections: true,
      maxConnections: 20,
      minDistance: 1,
      visible: false
    },
    particles: {
      colorMode: 'solid',
      color: '#d6c23f',
      transparency: 0.125 + (window.innerWidth < 800 ? 0.2 : 0),
      shape: 'circle',
      boundingBox: 'canvas',
      count: Math.max(140 - (10 * (1/ratio)), 90),
      minSize: 9 + (15 * (window.innerWidth / 1920)),
      maxSize: 16 + (26 * (window.innerWidth / 1920)),
      visible: true,
      distToParticles: Math.min(500 + (115 * (1/ratio)), 700)
    },
    cameraControls: {
      enabled: false,
      enableDamping: false,
      dampingFactor: 0.0,
      enableZoom: false,
      autoRotate: false,
      autoRotateSpeed: 0.3,
      resetCameraFlag: false,
      FOV: Math.max(75 * (ratio / 1.75), 35)
    },
    maxConnections: 0
  };


function render3DParticleBG(elem) {
    ReactDOM.render(<ParticleField config={config} />, elem);
}
window.render3DParticleBG = render3DParticleBG